import Block from '../block'

export default class NavSidebar extends Block {
	static title = 'nav-sidebar'

	constructor($el) {
		super($el)

		// open side menu
		this.$el.findElement('toggle').on('click', () => {
			if (this.isOpen()) {
				this.close()
			} else {
				this.open()
			}
		})

		this.$el.findElement('overlay').on('click', () => this.close())

		$(document).on('keydown', (e) => {
			if (e.key === 'Escape' && this.isOpen()) {
				this.close()
				this.$el.findElement('toggle').get(0)?.focus()
			}
		})

		$(document).on('product:add', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:remove', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})

		$(document).on('product:update', (index, data) => {
			this.$el.findElement('count--span').text(data.count)
		})
	}

	isOpen() {
		return (
			this.$el.hasClass('nav-sidebar--active') &&
			!this.$el.hasClass('nav-sidebar--closing')
		)
	}

	open() {
		this.closing = null
		this.$el.removeClass('nav-sidebar--closing').addClass('nav-sidebar--active')
		this.syncExpanded()
	}

	// the closing modifier runs the theme's exit animations; the sidebar only collapses once they finish
	async close() {
		const token = (this.closing = {})
		const $targets = this.$el
			.findElement('inner')
			.add(this.$el.findElement('overlay'))

		this.$el.addClass('nav-sidebar--closing')
		this.syncExpanded()

		const running = $targets
			.get()
			.flatMap((el) => el.getAnimations({ subtree: true }))
			.filter((a) => a.effect?.getComputedTiming().endTime !== Infinity)

		await Promise.allSettled(running.map((a) => a.finished))

		// reopened mid-exit
		if (this.closing !== token) return

		this.closing = null
		this.$el.removeClass('nav-sidebar--active nav-sidebar--closing')
	}

	syncExpanded() {
		this.$el
			.findElement('toggle')
			.attr('aria-expanded', this.isOpen() ? 'true' : 'false')
	}
}
